// @ts-nocheck
import { borderTypes, sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import constants from "@store/constants";
import merge from "lodash/merge";

/** sizeVariantValues
 * ------------------------------------------------------------------------------------------
 * fontSize: Font size for label & field content (px)
 * height: Height of the field (px)
 * icon: Icon Size (px)
 * iconPadding: Padding Around icon (px) - Not Needed
 * descriptionLineSpacing: Spacing between the field and its label and hint & error (px)
 * borderRadius: Border radius if the field is set to "rounded" (px)
 * leftLabelPadding: Top spacing to align label vertically when labelPosition="left" (px)
 * --- Starter Custom Code
 * padding: Left and right padding for the field (px)
 * lineHeight: Line height, mostly for textareas (number)
 * descriptionFontSize: Font size for hint & error (px)
 * descriptionLineHeight: Line height for hint & error (number)
 */

merge(sizeVariantValues, {
    default: {
        fontSize: 16,
        height: 48,
        icon: 24,
        iconPadding: 0,
        descriptionLineSpacing: 8,
        borderRadius: 4,
        leftLabelPadding: 13,
        // Starter Custom Code
        padding: 16,
        lineHeight: 1.5,
        descriptionFontSize: 14,
        descriptionLineHeight: 1.375,
    },
    small: {
        fontSize: 15,
        height: 40,
        icon: 20,
        iconPadding: 0,
        descriptionLineSpacing: 7,
        borderRadius: 3,
        leftLabelPadding: 10,
        // Starter Custom Code
        padding: 13,
        lineHeight: 1.5,
        descriptionFontSize: 13,
        descriptionLineHeight: 1.375,
    },
    xsmall: {
        fontSize: 14,
        height: 32, // Store Custom Code
        icon: 18,
        iconPadding: 0,
        descriptionLineSpacing: 5,
        borderRadius: 3,
        leftLabelPadding: 9,
        // Starter Custom Code
        padding: 11,
        lineHeight: 1.375,
        descriptionFontSize: 12,
        descriptionLineHeight: 1.375,
    },
});

/** borderTypes
 ----------------------------------------------------------------------------------------------------
 * color: Border color (theme)
 * width: Border width (px)
 * borderPaddingRule: Input padding - Not needed (using sizeVariant "padding" property)
 * textAreaBorderPaddingRule: Text areas padding - Not needed (using sizeVariant "padding" property)
 * underlinePaddingRule: Input underline padding - Not needed
 * textAreaUnderlinePaddingRule: Text areas underline padding - Not needed
 */

merge(borderTypes, {
    inactive: {
        // Default State
        color: "colors.common.border",
        width: constants.formField.borderWidth,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
        underlinePaddingRule: "",
        textAreaUnderlinePaddingRule: "",
    },
    focus: {
        color: "focus.color",
        width: constants.formField.borderWidth,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
        underlinePaddingRule: "",
        textAreaUnderlinePaddingRule: "",
    },
    error: {
        color: "colors.danger.main",
        width: constants.formField.borderWidth,
        borderPaddingRule: "",
        textAreaBorderPaddingRule: "",
        underlinePaddingRule: "",
        textAreaUnderlinePaddingRule: "",
    },
});
